import React from "react";
import classNames from "classnames";
import styles from "./LoaderLine.scss";

export const LoaderLine = () => {
    return (
        <div className={styles.base}>
            <div className={classNames(styles.bar, styles.bar1)}></div>
            <div className={classNames(styles.bar, styles.bar2)}></div>
        </div>
    );
};
